import { render, staticRenderFns } from "./BpSelect.vue?vue&type=template&id=59957f9f&"
import script from "./BpSelect.vue?vue&type=script&lang=js&"
export * from "./BpSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports